/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationType = {
  ANNOUNCEMENT: 'ANNOUNCEMENT',
  PROMOTION: 'PROMOTION',
  ACCOUNT: 'ACCOUNT',
  SYSTEM: 'SYSTEM',
  WITHDRAW_APPROVED: 'WITHDRAW_APPROVED',
  WITHDRAW_FAILED: 'WITHDRAW_FAILED',
  MARKET_RESOLUTION: 'MARKET_RESOLUTION',
  POSITION_VALUE_CHANGE: 'POSITION_VALUE_CHANGE',
  ORDER_FILLED: 'ORDER_FILLED',
  NEW_MARKET: 'NEW_MARKET',
  LIMIT_ORDER_EXPIRED: 'LIMIT_ORDER_EXPIRED',
  ORDER_CANCELLED: 'ORDER_CANCELLED',
  MARKET_CLOSING_SOON: 'MARKET_CLOSING_SOON',
  MONETIZATION_EXPERIENCE_STARTED: 'MONETIZATION_EXPERIENCE_STARTED',
  MONETIZATION_EXPERIENCE_CLAIMED: 'MONETIZATION_EXPERIENCE_CLAIMED',
  MONETIZATION_EXPERIENCE_EXPIRING: 'MONETIZATION_EXPERIENCE_EXPIRING',
  MONETIZATION_EXPERIENCE_EXPIRED: 'MONETIZATION_EXPERIENCE_EXPIRED',
  SIGNUP_VERIFICATION_REMINDER: 'SIGNUP_VERIFICATION_REMINDER',
  COMMENT_REPLY: 'COMMENT_REPLY',
} as const;
